import React from 'react'
import Select, { MultiValue } from 'react-select'
import styled from 'styled-components'
import { defs } from 'components/Shared/defs'
import { device } from 'components/Shared/device'
import {
  DayforceWebhookEventTypes,
  DayforceWebhookStatus,
} from 'pages/Dayforce/constants'
import { useDayforceWebhooksContextValue } from '../context/DayforceWebhooksProvider'

type Option = { label: string; value: string }

const eventTypeOptions: Option[] = Object.entries(
  DayforceWebhookEventTypes
).map(([value, label]) => ({ value, label }))

const statusOptions: Option[] = Object.entries(DayforceWebhookStatus).map(
  ([value, label]) => ({ value, label })
)

const findSelectedOptions = (options: Option[], values: string[] | null) =>
  values ? options.filter((o) => values.includes(o.value)) : []

const toValues = (selected: MultiValue<Option>) => selected.map((o) => o.value)

export const DayforceWebhooksFilterBar = () => {
  const {
    state: { agencies, filters },
    actions: { setFilters },
  } = useDayforceWebhooksContextValue()

  const agencyOptions: Option[] = Object.values(agencies).map((agency) => ({
    label: agency.name,
    value: agency.id,
  }))

  return (
    <FilterBarWrapper showBorderTop showBorderBottom>
      <SelectGroup>
        <Select
          isMulti
          isClearable
          isSearchable
          options={agencyOptions}
          styles={customStyles}
          name="agencyId"
          placeholder="Agency"
          value={findSelectedOptions(agencyOptions, filters.agencyId)}
          onChange={(selected) => setFilters({ agencyId: toValues(selected) })}
          closeMenuOnSelect={false}
        />
        <Select
          isMulti
          isClearable
          isSearchable
          options={eventTypeOptions}
          styles={customStyles}
          name="eventType"
          placeholder="Event type"
          value={findSelectedOptions(eventTypeOptions, filters.eventType)}
          onChange={(selected) => setFilters({ eventType: toValues(selected) })}
          closeMenuOnSelect={false}
        />
        <Select
          isMulti
          isClearable
          isSearchable
          options={statusOptions}
          styles={customStyles}
          name="status"
          placeholder="Status"
          value={findSelectedOptions(statusOptions, filters.status)}
          onChange={(selected) => setFilters({ status: toValues(selected) })}
          closeMenuOnSelect={false}
        />
      </SelectGroup>
    </FilterBarWrapper>
  )
}

const customStyles = {
  container: (provided: Record<string, unknown>) => ({
    ...provided,
    minWidth: 220,
    marginRight: defs.marginM,
    marginTop: defs.marginXS,
    marginBottom: defs.marginXS,
    fontSize: defs.fontS,
  }),
}

const FilterBarWrapper = styled.div<{
  showBorderTop?: boolean
  showBorderBottom?: boolean
}>`
  border-bottom: ${(props) => (props.showBorderBottom ? '1px solid' : null)};
  border-top: ${(props) => (props.showBorderTop ? '1px solid' : null)};
  border-color: ${defs.veryLightBlack};
  padding: ${defs.paddingS};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fafafa;
  @media ${device.smallerThanMobileL} {
    font-size: ${defs.fontS};
    height: 100%;
    padding-left: ${defs.paddingM};
  }
`

const SelectGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`
